function padString(s: string): string {
    // Pad the string with zeros in front if it is less than 10 characters long
    return s.padStart(10, "0");
}

/**
 * Formats a CIK identifier passed as a number or string
 * If CIK is not valid, function returns null
 *
 * @param {string|number|null} cik - The CIK identifier
 */
export function parseCIK(cik: string | number | null) {
    // Return null if CIK is null
    if (cik === null) {
        return null;
    }

    // If CIK is a numeric string -> parse the number and return number padded out to 10 digits
    if (typeof cik === "string") {
        const numericValue = parseInt(cik, 10);

        // If the parsed CIK is not a number -> return null
        if (Number.isNaN(numericValue)) {
            return null;
        }

        // Return the CIK value padded out to 10 digits
        return padString(cik);
    }

    // If CIK value is an integer -> pad out to 10 digits
    if (Number.isInteger(cik)) {
        return padString(String(cik));
    }

    // Otherwise, return null
    return null;
}
